import Footer from '../../sections/footer/Footer'
import BackToTopButton from '../../components/backToTopButton/BackToTopButton'

import './style.scss'
import ExpandingList, { ListItem } from '../../components/expandingList/ExpandingList';
import { useEffect, useState } from 'react'
import HeaderPages from '../../sections/header/HeaderPages';

type TabData = {
	title: string,
	questions: ListItem[]
}

function FaQ() {
	const [tabIndex, setTabIndex] = useState<number>(0)
	const [faqData, setFaqData] = useState<TabData[] | undefined>(undefined)

	useEffect(() => {
		if (faqData === undefined) {
			const listPromise = fetch('/data/faq.json')
			listPromise.then((res) => res.json())
				.then((listJson: {tabs: TabData[]}) => {
					console.log(listJson)
					setFaqData(listJson.tabs)
				})
		}
	}, [faqData])

	const tabClickHandler = (newIndex: number) => {
		setTabIndex(newIndex)
	}
	
	return (
		<>
			<div className='section-wrap section-seperator'>
				<div className='section-content'>
					<HeaderPages />
				</div>
			</div>
			<div className='section-wrap section-seperator'>
				<div className='section-content faq-section-content'>
					{faqData && (
						<div className='faq-tab-wrap'>
							{faqData.map((tab: TabData, index: number) => 
								<div 
									className={`faq-tab-item ${tabIndex === index ? 'faq-tab-item-active' : ''}`}
									key={`tablabel${index}`}
									onClick={() => tabClickHandler(index)}
								>{tab.title}</div>
							)}
						</div>
					)}
					<div className='faq-message'>Got questions? We've got answers.</div>
					<div className='faq-title'>Frequently Asked Questions</div>
					{faqData && faqData[tabIndex] && (
						<ExpandingList items={faqData[tabIndex].questions} />
					)}
				</div>
			</div>
			<div className='section-wrap section-seperator'>
				<div className='section-content'>
					<Footer />
				</div>
			</div>
			<BackToTopButton />
		</>
	)
}

export default FaQ
